import { render } from "./mealRecord.vue?vue&type=template&id=76a878ac&scoped=true"
import script from "./mealRecord.vue?vue&type=script&lang=js"
export * from "./mealRecord.vue?vue&type=script&lang=js"

import "./mealRecord.vue?vue&type=style&index=0&id=76a878ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a878ac"]])

export default __exports__